import React, {forwardRef, useEffect, useImperativeHandle} from 'react'
import PropTypes from 'prop-types'

import {Section}   from "../../02-Molecules/Section/Section"
import {FormField} from "../../02-Molecules/FormField/FormField"
import { FormCheckbox } from '../../01-Atoms/FormCheckbox/FormCheckbox'
import { FormInput } from '../../01-Atoms/FormInput/FormInput'
import { Textarea } from '../../01-Atoms/Textarea/Textarea'
import { FormDatePicker } from '../../01-Atoms/FormDatePicker/FormDatePicker'

/**
 * Section for recipient details
 */
export const SectionRecipientDetails = forwardRef(({ collapsed, heading, headingLarge, loqateKey, fields, onInputChange, required, sectionId, recap, textAfter, textBefore, tracking, trackEvent, validationHash, values, staticText,  ...props }, ref) => {
  const eighteenYearsAgo = new Date();
  eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear()-18);
  const { about_recipient_text_before, about_recipient_text_after } = staticText.recipient_details;

  const isValid = () => {
    const keys = [
      'recipient_title',
      'recipient_first_name',
      'recipient_last_name'
    ]

    const coreFieldValidity = keys.reduce((isValid, key) => values[key] === '' ? false : isValid, true)
    // const ageFieldValidity  = values['recipient_under_eighteen'] ? ( typeof values['recipient_date_of_birth'] !== 'undefined' && values['recipient_date_of_birth'] !== '') : true

    return coreFieldValidity && !values['recipient_under_eighteen'];
  }

  useImperativeHandle(ref, () => ({
    isValid: ()  => isValid(),
  }))

  // hide all other fields if recipient under 18 is checked
  useEffect(() => {
    if (document) {
      const sections = document.querySelectorAll('.o-form-step__column-content section:not(.m-section__recipient-details)')
      const actions = document.querySelector('.o-form-step__column-content .o-form-step__actions')
      console.log('NDR', sections);
      if (sections) {
        if (values.recipient_under_eighteen) {
          // hide sections
          sections.forEach(section => section.style.display = 'none');
          actions.style.display = 'none';
        } else {
          // show sections
          sections.forEach(section => section.style.display = '')
          actions.style.display = '';
        }
      }
    }
  }, [values.recipient_under_eighteen])

  return (
    <Section sectionClass="recipient-details" tracking={tracking} trackEvent={trackEvent} collapsed={collapsed} heading={heading} headingLarge={headingLarge} sectionId={sectionId} textBefore={about_recipient_text_before} textAfter={about_recipient_text_after}>
      <div>
        { !values.recipient_under_eighteen && <>
        <FormField
          label={'Title'}
          name={'recipient_title'}
          type={'select'}
          required={true}
          onInputChange={onInputChange}
          options={ [
            { value: 'Miss', label: 'Miss' },
            { value: 'Ms', label: 'Ms' },
            { value: 'Mr', label: 'Mr' },
            { value: 'Mrs', label: 'Mrs' },
            { value: 'Dr', label: 'Dr' },
            { value: 'Reverend', label: 'Reverend' },
            { value: 'Professor', label: 'Professor' },
            { value: 'Other', label: 'Other' },
          ]}
          value={values.recipient_title}
          validationHash={validationHash}
        />

        <FormField
          label={'Recipient first name'}
          name={'recipient_first_name'}
          type={'text'}
          required={true}
          onInputChange={onInputChange}
          value={values.recipient_first_name}
          validationHash={validationHash}
          validationMessages={ [
            { type: 'valueMissing', message: 'Please provide a first name' }
          ]}
        />

        <FormField
          label={'Recipient last name'}
          name={'recipient_last_name'}
          type={'text'}
          required={true}
          onInputChange={onInputChange}
          value={values.recipient_last_name}
          validationHash={validationHash}
          validationMessages={ [
            { type: 'valueMissing', message: 'Please provide a last name' }
          ]}
        />
        </>}

        <FormCheckbox
          label={'Recipient is under eighteen'}
          name={'recipient_under_eighteen'}
          checked={false}
          onInputChange={onInputChange}
          // onInputChange={customValidation}
          value={values.recipient_under_eighteen}
          validationHash={validationHash}
          required={false}
          />

        {values.recipient_under_eighteen &&
          <>
            <div className="b-form-input__error-wrapper b-form-input__error-wrapper--inline">
              <span className='b-form-input__error-message' id='recipient_under_eighteen_error' aria-live="assertive">
                We're sorry, we're currently unable to process gifts for under-18s. <br />
                If you'd like to continue please complete this form for the parent or guardian of the child you are buying a gift for.
              </span>
            </div>
            </>
        }

        {/* {values.recipient_under_eighteen &&
          <>
            <div className='m-section__row'>
              Please tell us your recipient's age. We use this data to tailor our communications to minors.
            </div>
            <FormDatePicker
              label={"Please enter recipient date of birth"}
              onInputChange={onInputChange}
              dateFormat="MM/yyyy"
              placeholder="01/2021"
              showMonthYearPicker
              required={true}
              name="recipient_date_of_birth"
              id='recipient_date_of_birth'
              minDate={eighteenYearsAgo}
              minAge={13}
              validationHash={validationHash}
              validationMessages={
                [
                  { type: 'valueMissing', message: 'Please provide your recipient\'s date of birth' },
                ]
              }
              />
            </>
        } */}

        {!values.recipient_under_eighteen &&<>
        <FormCheckbox
          label={'Would you like to send an e-card with this gift?'}
          name={'recipient_with_e_card'}
          checked={values.recipient_with_e_card || false}
          onInputChange={onInputChange}
          value={values.recipient_with_e_card}
          validationHash={validationHash}
          required={false}
          />

        {values.recipient_with_e_card &&
        <>
          <FormInput
            label={'Please enter the e-card recipient email address'}
            name={'recipient_e_card_email'}
            type={'email'}
            loqateKey={loqateKey}
            value={values.recipient_e_card_email}
            onInputChange={onInputChange}
            validationHash={validationHash}
            required={true}
            validationMessages={
              [
                { type: 'valueMissing', message: 'Please provide an email address' },
                { type: 'typeMismatch', message: 'Please enter a valid email address' },
                { type: 'patternMismatch', message: 'Please enter a valid email address'},
                { type: 'maxlength', maxlength: 500 },
              ]
            }
            />
          <Textarea
            label={'E-card message'}
            name={'recipient_e_card_message'}
            value={values.recipient_e_card_message || ''}
            onInputChange={onInputChange}
            validationHash={validationHash}
            required={true}
            rows={6}
            cols={50}
            resizable={false}
            validationMessages={
              [
                { type: 'maxlength', maxlength: 250 },
              ]
            }
            />
          </>
        }
        </>}
      </div>
    </Section>
  )
})

SectionRecipientDetails.propTypes = {
  collapsed    : PropTypes.bool,
  required     : PropTypes.bool,
  heading      : PropTypes.string,
  headingLarge : PropTypes.bool,
  sectionId    : PropTypes.string,
  textAfter    : PropTypes.string,
  textBefore   : PropTypes.string,
  onInputChange: PropTypes.func,
  values: PropTypes.shape({
    payment_reason      : PropTypes.string,
    payment_reason_other: PropTypes.string,
  }),
  tracking: PropTypes.shape({
    id  : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    type: PropTypes.oneOf(['entry', 'exit', 'entry_exit'])
  }),
  trackEvent: PropTypes.func,
  staticText: PropTypes.shape({
    recipient_details: PropTypes.shape({
      about_recipient_text_before: PropTypes.string,
      about_recipient_text_after: PropTypes.string,
    })
  }),
  fields        : PropTypes.arrayOf(PropTypes.object),
  validationHash: PropTypes.string,
}

SectionRecipientDetails.defaultProps = {
  collapsed: false,
  recap    : false,
  required : false
}
